<template>
	<div class="groupware-selected-file-list" data-test="groupware-selected-file-list">
		<div class="d-flex align-center justify-space-between">
			<span class="text-subtitle-2">
				{{ t("SELECTED_FILES") }}
				<span data-test="selected-count">{{ props.items.length }} / {{ props.max }}</span>
			</span>
			<v-btn color="primary" variant="text" rounded size="small" data-test="proceed-button"
				:disabled="!canProceed" @click="emit('proceed')">
				{{ t("NEXT") }}
			</v-btn>
		</div>
		<div class="text-caption" data-test="pair-hint">{{ t("TIFF_PAIR_SELECTION_HINT") }}</div>
		<v-list v-if="props.items.length" density="compact" class="pa-0 bg-transparent">
			<v-list-item v-for="item in props.items" :key="groupwareItemKey(item)" class="px-0" min-height="32">
				<v-list-item-title class="selected-file-name">{{ item.name }}</v-list-item-title>
				<template #append>
					<v-btn icon variant="text" size="x-small" data-test="remove-button"
						:aria-label="`${t('CANCEL')}: ${item.name}`" @click="emit('remove', groupwareItemKey(item))">
						<v-icon size="small">mdi-close</v-icon>
					</v-btn>
				</template>
			</v-list-item>
		</v-list>
	</div>
</template>

<script setup lang="ts">
import type { GroupwareSelectedItem } from "@/components/AddData/groupwareSelection.types";
import { groupwareItemKey } from "@/components/AddData/groupwareSelectionResolver";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps<{
	/** 積み上げ済みの tiff（0〜max 件） */
	items: readonly GroupwareSelectedItem[];
	/** 組を成す件数（DTM / オルソは 2） */
	max: number;
}>();

const emit = defineEmits<{
	/** 個別取消。引数は groupwareItemKey の値（GI-30） */
	(e: "remove", key: string): void;
	/** 組が揃っているときだけ活性の「次へ」。種別選択へ再進入する導線 */
	(e: "proceed"): void;
}>();

const { t } = useI18n();

const canProceed = computed(() => props.items.length === props.max);
</script>

<style scoped>
.groupware-selected-file-list {
	margin-top: 8px;
}

/* 長いファイル名も全体が読めるよう折り返す */
.selected-file-name {
	word-break: break-all;
	white-space: normal;
}
</style>
